import { createSlice } from "@reduxjs/toolkit";
import { Staff } from "../../common/interfaces/staff";
import { getClubsScoutById, getClubsScoutsByFilter } from "./clubsScoutsActionAsync";

export type ClubsScoutsState = {
  isLoading: boolean;
  count: number;
  scout?: Staff[];
  scoutPerson?: Staff;
};

export const clubsScoutsInitialState: ClubsScoutsState = {
  isLoading: false,
  count: 0,
};

export const { actions: clubsScoutsActions, reducer: clubsScoutsReducer } = createSlice({
  name: "clubsScouts",
  initialState: clubsScoutsInitialState,
  reducers: {
    resetScout(state) {
      state.scoutPerson = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClubsScoutsByFilter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClubsScoutsByFilter.fulfilled, (state, { payload }) => {
        state.count = payload.count;
        state.scout = payload.staff;
        state.isLoading = false;
      })
      .addCase(getClubsScoutsByFilter.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getClubsScoutById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClubsScoutById.fulfilled, (state, { payload }) => {
        state.scoutPerson = payload;
        state.isLoading = false;
      })
      .addCase(getClubsScoutById.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
